import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { APIService } from '../api/api.service'
import { LocalStorageService } from '../local-storage/local-storage.service';
import { AppearanceService } from '../appearance/appearance.service';
import { Constants } from '../../constants/constants';
import { UserService } from '../user/user.service';
import { throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class OrganisationService 
{
  constructor(private apiService: APIService, private localStorageService: LocalStorageService,
    private appearanceService: AppearanceService, private userService: UserService) 
  {
    this.initService();
  }


  initService()
  {
    this.apiService.baseUrl = Constants.PROD_URL;

    this.appearanceService.listenForEvent('storage:loaded', (data: any) => {

      this.loadFromLocalData();

    });
  }


  loadFromLocalData() 
  {

  }


  public getEmployeeDetails(userUid, clientUid, organisationUid): any 
  { 
    var payload = {
      UserUid: userUid,
      ClientUid: clientUid,
      OrganisationUid: organisationUid
    }

    return this.apiService.getEmployeeDetails(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }
}
